<template>
  <div class="mt-3 pa-4 grey lighten-4">
    <h5>Requisição</h5>

    <SGPFormInputComponent
      type="text"
      name="max"
      v-model="formulario.requisicao.endpoint"
      placeholder="Url da lista de dados"
      placeholderText="Url da lista de dados"
      class=""
      stylized
      solo
    />

    <div class="row">
      <SGPFormInputComponent
        type="text"
        name="gatilho"
        v-model="formulario.requisicao.gatilho"
        placeholder="Gatilho"
        placeholderText=""
        class="col-6"
        stylized
        solo
      />
      <SGPFormInputComponent
        type="text"
        name="metodo"
        v-model="formulario.requisicao.metodo"
        placeholder="Método"
        placeholderText="Método"
        class="col-6"
        stylized
        solo
      />

      <SGPFormInputComponent
        type="text"
        name="option_label"
        v-model="formulario.requisicao.option_label"
        placeholder="Label (chave)"
        placeholderText="Label (chave)"
        class="col-6"
        stylized
        solo
      />
      <SGPFormInputComponent
        type="text"
        name="metodo"
        v-model="formulario.requisicao.option_value"
        placeholder="Valor"
        placeholderText="Valor"
        class="col-6"
        stylized
        solo
      />

      <SGPFormSelectComponent
      v-if="options.length"
        titulo="Como o campo será apresentado dessa forma no formulário!"
        :listaDeOptions="options"
        optionLabel="label"
        optionValue="value"
        placeholder=""
        placeholderText=""
        class="col-12"
        stylized
        mostrarSelecione
        solo
      />
    </div>

    <SGPFormBotaoComponent
      @click="testarRequisicao"
      class="mt-3 text-capitalize"
      :loading="loading"
      outlined
    >
      <SGPIconComponent >{{ loading ? 'mdi-search-web' : 'mdi-search-web' }}</SGPIconComponent>
      Testar requisição
    </SGPFormBotaoComponent>

    

  </div>
</template>


<script>
import HttpClient from '@/common/boot/HttpClient'
import criarToast from '@/common/boot/ToastsHandler'

export default {
  name: "RequisicaoCampoComponent",
  props: {
    formulario: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      options: []
    }
  },

  created () {
    this.formulario.requisicao.gatilho = 'load'
    this.formulario.requisicao.metodo = 'GET'
  },

  methods: {
    async testarRequisicao() {
      this.loading = true
      let options = []
      
      try {
        let response = await HttpClient({
          method: this.formulario.requisicao.metodo,
          url: this.formulario.requisicao.endpoint
        })

        let item = this.formulario

        if (response.status == 200) {
          response.data.data.forEach(respItem => {
            const objOption = {
              label: respItem[item.requisicao.option_label],
              value: respItem[item.requisicao.option_value]
            }              
            options.push(objOption)
          })

          this.options = options
        }
      } catch (error) {
        criarToast({
          tipo: 'error',
          mensagem: 'Não foi possível carregar os dados, verifique a URL e tente novamente!'
        })
      }

      this.loading = false
    }
  }
}
</script>